export const defaultLoadMoreLimit = 50
export const defaultPaginationLimit = 18
export const defaultTotal = 0
export const initialPage = 1
